module.exports = __webpack_public_path__ + "img/sgs_logo.8c15db4b.png";